import { queryClient } from './query-client';

import { CookieManager } from '../utility/cookie-manager';

export async function logoutUser() {
  await queryClient.removeQueries();
  CookieManager.removeAuthTokens();
}
